import React, { Component } from 'react';
import { connect } from 'react-redux';
import { history } from '../../../store';

 class Imprint extends Component {

  render() {
    return (
      <div className="view">
        <div style={{textAlign:"center"}}>
          <button style={{marginTop:"50px", marginBottom: "2em"}}className="btn btn-outline-primary" onClick={(e) => history.goBack()}>{this.props.language.map.labels.common.back}</button>
        </div>
        <div className="row">
          {
            this.props.language.map !== null ?
            <div style={{marginTop:"2em"}} className="offset-xl-2 offset-lg-2 offset-md-1 col-xl-8 col-lg-8 col-md-10 col-sm-11 col-xs-12">
              <h3>{this.props.language.map !== null ? this.props.language.map.header.imprint.header1 : ""}</h3>
                <div>{this.props.language.map.static.imprint.legal.labels.hoster}</div>
                <div>{this.props.language.map.static.imprint.address.company}</div>
                <div>{this.props.language.map.static.imprint.address.street}</div>
                <div>{this.props.language.map.static.imprint.address.zip} &nbsp; {this.props.language.map.static.imprint.address.city}</div>
                {this.props.language.map.static.imprint.address.country}<br></br>
                <br></br>
                <p>
                {this.props.language.map.static.imprint.address.phone}<br></br>
                {this.props.language.map.static.imprint.address.fax}<br></br>
                <a href={"mailto:"+this.props.language.map.static.imprint.address.email}>{this.props.language.map.static.imprint.address.email}</a><br></br>
              </p>
              <p>
                {this.props.language.map.static.imprint.legal.labels.trade}<br></br>
                {this.props.language.map.static.imprint.legal.values.trade}
              </p>
              <p>
                {this.props.language.map.static.imprint.legal.labels.vat} &nbsp;{this.props.language.map.static.imprint.legal.values.vat}
              </p>
              <p>
                {this.props.language.map.static.imprint.legal.labels.ceo}<br></br>
                {this.props.language.map.static.imprint.legal.values.ceo}
              </p>
              <p>
                {this.props.language.map.static.imprint.text.p1}
              </p>
              <p>
                {this.props.language.map.static.imprint.text.p2}
              </p>
              <p>
                {this.props.language.map.static.imprint.text.p3}
              </p>
              <div style={{textAlign:"center"}}>
                <button style={{marginTop:"50px", marginBottom: "5em"}}className="btn btn-outline-primary" onClick={(e) => history.goBack()}>{this.props.language.map.labels.common.back}</button>
              </div>
            </div>
            :
            null
          }

        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  language: state.application.language
});

const mapDispatchToProps = (dispatch) => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(Imprint);



// WEBPACK FOOTER //
// ./src/modules/imprint/view/Imprint.js